/**
 * Test redesigning the logged-out category page:
 * https:www.notion.so/faire/Category-page-optimizations-Phase-1-0da4c22181ac463fb11845360090fe0a
 */
export const ENABLE_LOGGED_OUT_CATEGORY_PAGE_REDESIGN_241016 = 'ENABLE_LOGGED_OUT_CATEGORY_PAGE_REDESIGN_241016';
